import {Image} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import ImageDucky from '../../../assets/images/ducky.png'

import Styles from './ColorDivider.module.css'

export const COLOR_DIVIDER_VARIANTS = ['1', '2', '3'] as const

export interface ColorDividerProps {
  variant: (typeof COLOR_DIVIDER_VARIANTS)[number]
  isThick?: boolean
  hasDucky?: boolean
}

export const defaultProps: Partial<ColorDividerProps> = {}

const BLOCK_COLORS = {
  '1': ['blue', 'greenLight', 'blue', 'purple', 'pink', 'green'],
  '2': ['purple', 'pink', 'blueLight', 'greenLight', 'blueLight', 'greenDark'],
  '3': ['borderSubtle', 'borderDefault', 'blueLighter', 'pink', 'purple', 'green', 'greenLight', 'purple'],
} as const satisfies Record<(typeof COLOR_DIVIDER_VARIANTS)[number], readonly string[]>

export const ColorDivider = (props: ColorDividerProps) => {
  const initializedProps: ColorDividerProps = {...defaultProps, ...props}
  const {variant, isThick, hasDucky} = initializedProps

  return (
    <div className={clsx(Styles['ColorDivider'], isThick && Styles['ColorDivider--thick'])} aria-hidden="true">
      {BLOCK_COLORS[variant].map((color, index) => (
        <div
          // eslint-disable-next-line @eslint-react/no-array-index-key -- Each block occupies a fixed slot in the strip.
          key={index}
          className={clsx(Styles['ColorDivider__block'], Styles[`ColorDivider__block--${color}`])}
        />
      ))}
      {hasDucky && <Image src={ImageDucky} alt="" className={Styles['ColorDivider__ducky']} />}
    </div>
  )
}
